/** Firestore document id: BillNo_ProductID (sanitized). */
export function salesTransactionDocId(billNo, productId) {
  const bill = sanitizeDocIdPart(billNo);
  const pid = sanitizeDocIdPart(productId);
  return ensureValidDocId(`${bill}_${pid}`, billNo, productId);
}

export function sanitizeDocIdPart(value) {
  return String(value ?? "")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[/\\.#$[\]]/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 400);
}

function simpleHash(s) {
  let h = 0;
  const str = String(s);
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h).toString(36);
}

/**
 * Firestore IDs: no "/", not "." or "..", not __.*__, max 1500 bytes.
 */
export function ensureValidDocId(candidate, billNo, productId) {
  let id = String(candidate ?? "").trim();
  if (!id || id === "_" || id === "." || id === "..") {
    id = `sale_${simpleHash(billNo)}_${simpleHash(productId)}`;
  }
  if (/^__.*__$/.test(id)) {
    id = `sale_${simpleHash(id)}`;
  }
  if (id.length > 1200) {
    id = `${id.slice(0, 500)}_${simpleHash(billNo)}_${simpleHash(productId)}`;
  }
  return id;
}

export function isValidFirestoreDocId(id) {
  if (!id || typeof id !== "string") return false;
  if (id === "." || id === "..") return false;
  if (id.includes("/")) return false;
  if (/^__.*__$/.test(id)) return false;
  if (id.length > 1500) return false;
  return true;
}
